import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import {
    Form,
    Field,
    Popup,
    Picker,
    Stepper,
    DatetimePicker,
    CheckboxGroup,
    Button,
    Toast,
    Empty,
    Dialog,
    Overlay,
    Icon,
    Checkbox,
    Tab, 
    Tabs,
    Image as VanImage
} from 'vant'
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(VanImage);
Vue.use(Overlay);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Stepper);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);



// WEBPACK FOOTER //
// ./src/utils/vantConfig.js